/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_LOOSENESS_RESULT,
	GET_LOOSENESS_RESULT_SUCCESS,
	GET_LOOSENESS_RESULT_ERROR,
	RESET_LOOSENESS_RESULT,
} from "@/stores/actions/WindDiagnosticLoosenessResult";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status: FetchStatus.Init,
	data:   {
		lssLoosenessResult:        0,
		imsLoosenessResult:        0,
		hssLoosenessResult:        0,
		genLoosenessResult:        0,
		generatorSignalSettingIds: [],
		hssSignalSettingIds:       [],
		imsSignalSettingIds:       [],
		lssSignalSettingIds:       []
	},
	error: {},
};

const actions = {
	[GET_LOOSENESS_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_LOOSENESS_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/RollingBearingLooseness`)
			.then((resp) =>
			{
				commit(GET_LOOSENESS_RESULT_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_LOOSENESS_RESULT_ERROR, error.response);
			});
	},
	[RESET_LOOSENESS_RESULT]: ({ commit }) =>
	{
		commit(RESET_LOOSENESS_RESULT);
	},
};

const mutations = {
	[GET_LOOSENESS_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_LOOSENESS_RESULT_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.data = data;
	},
	[GET_LOOSENESS_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_LOOSENESS_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.data.lssLoosenessResult = DiagnosticRange.undefined;
		state.data.imsLoosenessResult = DiagnosticRange.undefined;
		state.data.hssLoosenessResult = DiagnosticRange.undefined;
		state.data.genLoosenessResult = DiagnosticRange.undefined;
	},
};

export default {
	state,
	actions,
	mutations,
};
